import { api } from "../api/api";
import { GetPlanFeatureResponseDTO } from "../models/planFeature/planFeture.response";
import { CreatePlanFeatureRequestDTO } from "../models/planFeature/planFeature.request";
import { ApiResponse } from "../models/base/ApiResponse";


export const planFeatureService = {

    async getPlanFeatures(): Promise<ApiResponse<GetPlanFeatureResponseDTO[]>> {
        const {data} = await api.get<ApiResponse<GetPlanFeatureResponseDTO[]>>("/planfeatures");
        return data;
    },

    async createPlanFeature(dto: CreatePlanFeatureRequestDTO): Promise<ApiResponse<string>> {
        const {data} = await api.post<ApiResponse<string>>("/planfeatures", dto);
        return data;
    },

    async deletePlanFeatures(ids: string[]): Promise<ApiResponse<string>> {
        const {data} = await api.delete<ApiResponse<string>>("/planfeatures", { data: { ids } });
        return data;
    }
}